import React, { useState } from 'react';
import SpelEditor from './LazySpelEditor';

const AceSpelEditor = () => {
    const [value, setValue] = useState('');
    return <SpelEditor value={value} onChange={setValue} />;
};

export default AceSpelEditor;
